import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

const TABS = [
  { key: 'queue', path: '/print' },
  { key: 'freeform', path: '/print/freeform' },
  { key: 'templates', path: '/print/templates' },
  { key: 'printers', path: '/print/printers' },
] as const;

/**
 * The two halves of the printing desk: what is waiting, and what it prints with.
 *
 * Addresses rather than local state, so the hardware Back button on Android
 * walks between them and a link to the designer is a link somebody can send.
 */
export function PrintTabs() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const activeTab = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    activeTab.current?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }, [pathname]);

  return (
    <div className="tabs print-tabs" role="tablist">
      {TABS.map((tab) => (
        <button
          key={tab.key}
          ref={pathname === tab.path ? activeTab : null}
          type="button"
          role="tab"
          aria-selected={pathname === tab.path}
          className={pathname === tab.path ? 'tabs__tab is-active' : 'tabs__tab'}
          onClick={() => navigate(tab.path)}
        >
          {t(`labels.tab.${tab.key}`)}
        </button>
      ))}
    </div>
  );
}
